module.exports = {"632802001":"河西街道","632802002":"河东街道","632802003":"火车站街道","632802100":"尕海镇","632802101":"怀头他拉镇","632802102":"柯鲁柯镇","632802200":"蓄集乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/632802.json
// module id = 3018
// module chunks = 0